import styles from './StoreView.module.css'
import { useMemo } from 'react'
import { getPlatform } from '../utils/platform-utils'
import { useTranslation } from 'react-i18next'
import app_logo from '../assets/app_logo.png'
import app_logo_ios from './../assets/app_logo_ios.png'
import { HOSTING_CONFIG } from '../_Config'

const androidAppURL = new URL('https://play.google.com/store/apps/details')
androidAppURL.searchParams.append('id', HOSTING_CONFIG.ANDROID_CAMPAIGN_LINK_ID)
const refererParams = new URLSearchParams()
refererParams.append('utm_source', HOSTING_CONFIG.ANDROID_CAMPAIGN_LINK_SOURCE)
refererParams.append('utm_medium', HOSTING_CONFIG.ANDROID_CAMPAIGN_LINK_MEDIUM)
refererParams.append('utm_campaign', HOSTING_CONFIG.ANDROID_CAMPAIGN_LINK_CAMPAIGN)
androidAppURL.searchParams.append('referrer', refererParams.toString())

const iosAppURL = new URL('https://apps.apple.com/app/apple-store/id' + HOSTING_CONFIG.IOS_CAMPAIGN_LINK_ID)
iosAppURL.searchParams.append('pt', HOSTING_CONFIG.IOS_CAMPAIGN_LINK_PT)
iosAppURL.searchParams.append('ct', HOSTING_CONFIG.IOS_CAMPAIGN_LINK_CT)
iosAppURL.searchParams.append('mt', HOSTING_CONFIG.IOS_CAMPAIGN_LINK_MT)

export default function StoreView() {
  const platform = getPlatform()
  const showGooglePlayLink = platform === 'android' || platform === 'unknown'
  const showAppStoreLink = platform === 'ios' || platform === 'unknown'

  const {
    t,
    i18n: { resolvedLanguage },
  } = useTranslation()

  const appLogo = useMemo(() => {
    if (platform === 'ios') {
      return app_logo_ios
    } else {
      return app_logo
    }
  }, [platform])

  return (
    <div className={styles.root}>
      <img className={styles.app_logo} alt="" src={appLogo}></img>

      <span className={styles.description}>{t(platform === 'ios' ? 'descriptionIos' : 'description')}</span>

      <div className={styles.links}>
        {showGooglePlayLink ? (
          <div>
            <a href={androidAppURL.toString()}>
              <img alt={t('getItOnGooglePlay')} src={'locales/' + (resolvedLanguage ?? 'en') + '/google_play_badge.png'} />
            </a>
          </div>
        ) : (
          <></>
        )}
        {showAppStoreLink ? (
          <div>
            <a href={iosAppURL.toString()}>
              <img alt={t('getItOnAppStore')} src={'locales/' + (resolvedLanguage ?? 'en') + '/app_store_badge.svg'} />
            </a>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className={styles.legal_attribution}>
        {showGooglePlayLink ? <span>{t('legalAttributionGooglePlay')}</span> : <></>}
        {showAppStoreLink ? <span>{t('legalAttributionAppStore')}</span> : <></>}
      </div>
    </div>
  )
}
